import { render, staticRenderFns } from "./ProfileCard.component.vue?vue&type=template&id=11772c5e"
import script from "./ProfileCard.component.vue?vue&type=script&lang=js"
export * from "./ProfileCard.component.vue?vue&type=script&lang=js"
import style0 from "./ProfileCard.component.vue?vue&type=style&index=0&id=11772c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports